import findEntitiesByActionType from "../utils/findEntitiesByActionType";
import { createFormData } from "../utils/dataUtils";
import formatData from "../utils/formatData";
import formatConfig from "../utils/formatConfig";
import { getDependentPaths } from "../utils/storeUtils";
import translationService from "../app/TranslationService";
import { loadMissingComponents, loadInnerWidgets } from "./Loader";
import { addQueryParams } from "../utils/urlUtils";
import webuiState from "../app/InternalStateService";
import { constructRequestEntity } from "../utils/dataUtils";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

//GET UI config of a widget
export const WIDGET_REQUEST = "WIDGET_REQUEST";
export const WIDGET_SUCCESS = "WIDGET_SUCCESS";
export const WIDGET_FAILURE = "WIDGET_FAILURE";

//GET widget data
export const WIDGET_DATA_REQUEST = "WIDGET_DATA_REQUEST";
export const WIDGET_DATA_SUCCESS = "WIDGET_DATA_SUCCESS";
export const WIDGET_DATA_FAILURE = "WIDGET_DATA_FAILURE";

//POST widget data
export const WIDGET_POST_REQUEST = "WIDGET_POST_REQUEST";
export const WIDGET_POST_SUCCESS = "WIDGET_POST_SUCCESS";
//export const WIDGET_POST_FAILURE = "WIDGET_POST_FAILURE";

export const RELOAD_WIDGET_REQUEST = "RELOAD_WIDGET_REQUEST";
export const RELOAD_WIDGET_SUCCESS = "RELOAD_WIDGET_SUCCESS";
export const RELOAD_WIDGET_FAILURE = "RELOAD_WIDGET_FAILURE";

export const SEND_WIDGET_DATA_CONFIG_REQUEST = "SEND_WIDGET_DATA_CONFIG_REQUEST";
export const SEND_WIDGET_DATA_CONFIG_SUCCESS = "SEND_WIDGET_DATA_CONFIG_SUCCESS";
export const SEND_WIDGET_DATA_CONFIG_FAILURE = "SEND_WIDGET_DATA_CONFIG_FAILURE";

export const WIDGET_UPDATE_ENTITY_REQUEST = "WIDGET_UPDATE_ENTITY_REQUEST";
export const WIDGET_UPDATE_ENTITY_SUCCESS = "WIDGET_UPDATE_ENTITY_SUCCESS";
export const WIDGET_UPDATE_ENTITY_FAILURE = "WIDGET_UPDATE_ENTITY_FAILURE";

export const SET_WIDGET_STATE = "SET_WIDGET_STATE";
export const SET_WIDGET_CONTEXT = "SET_WIDGET_CONTEXT";

export const WIDGET_DATA_UPDATE = "WIDGET_DATA_UPDATE";

/* Widget actions */
function buildWidgetQueryParams(data, actionType) {
    let result = "";
    if (data && data.entities) {
        let entities = findEntitiesByActionType(data.entities, actionType);

        entities.forEach((element) => {
            let classifier = element.class && element.class[0] ? element.class[0] : "";
            let value =
                element.properties && element.properties.value ? element.properties.value : null;
            if (classifier && value) {
                result += `&${classifier}=${value}`;
            }
        });
    }
    return result;
}

export function submitWidget(sirenAction, widgetId) {
    const validateWidget = webuiState.getActionByName("validations.validateWidgetData");
    return (dispatch, getState) => {
        let endpoint = sirenAction.href || getWidgetUrl(widgetId, getState());
        let widgetData = getState().getIn(["data", widgetId]);
        let json = widgetData.toJS ? widgetData.toJS() : null;
        let payload;

        let dataValid = dispatch(validateWidget(json, widgetId));

        if (!dataValid) {
            return dispatch(
                webuiState.getActionByName("messages.triggerMessages")([
                    {
                        type: "error",
                        messages: [translationService.translate("enterValidInfo")]
                    }
                ])
            );
        }
        let outputParser = getOutputParser(widgetId, getState());
        payload = createFormData(json, sirenAction, outputParser, widgetId);
        return dispatch(submitWidgetData(endpoint, widgetId, payload));
    };
}

function updateWidgetWithQueryString(sirenAction, widgetId) {
    return (dispatch, getState) => {
        let endpoint = getWidgetUrl(widgetId, getState());
        let widgetData = getState().getIn(["data", widgetId]);
        let json = widgetData.toJS ? widgetData.toJS() : null;
        let query = buildWidgetQueryParams(json, sirenAction.actionType);
        query = query.replace(/^&/, "");
        if (query) {
            if (~endpoint.indexOf("?")) {
                endpoint = `${endpoint}&${query}`;
            } else {
                endpoint = `${endpoint}?${query}`;
            }
        }
        return dispatch(fetchWidgetData({ endpoint }, widgetId));
    };
}

//this action is similar to submitWidget except there is no validation
//and the endpoint is BE responsibility
function updateWidgetData(sirenAction, widgetId) {
    return (dispatch, getState) => {
        let endpoint = sirenAction.href;
        let widgetData = getState().getIn(["data", widgetId]);
        let json = widgetData.toJS ? widgetData.toJS() : null;
        let payload;

        let outputParser = getOutputParser(widgetId, getState());
        payload = createFormData(json, sirenAction, outputParser, widgetId);
        //the case of update other widget with current widget data
        //NB the endpoint should be the other widget href
        let dependentWidgets = sirenAction.dependencies;
        if (dependentWidgets && dependentWidgets.length) {
            return Promise.all(
                dependentWidgets.map((dependentWidget) => {
                    return dispatch(submitWidgetData(endpoint, dependentWidget, payload));
                })
            );
        }

        return dispatch(submitWidgetData(endpoint, widgetId, payload));
    };
}

export function updateWidget(sirenAction, widgetId, path) {
    if (sirenAction.method === "GET") {
        return updateWidgetWithQueryString(sirenAction, widgetId, path);
    } else {
        return updateWidgetData(sirenAction, widgetId, path);
    }
}

export function refreshWidget(sirenAction, widgetId) {
    let endpoint = sirenAction.href;
    let target = sirenAction.target || widgetId;

    return (dispatch, getState) => {
        if (!endpoint) {
            endpoint = getWidgetUrl(target, getState());
        }

        return dispatch(fetchWidgetData({ endpoint }, target));
    };
}

export function triggerRefreshWidget(widgetId) {
    return (dispatch, getState) => {
        let endpoint = getWidgetUrl(widgetId, getState());
        if (endpoint) {
            return dispatch(
                fetchWidgetData({ endpoint }, widgetId, {
                    actionType: "refreshWidget",
                    options: {}
                })
            );
        } else {
            WEBUILogs.warn("Unable to refresh widget!");
        }
    };
}

function submitWidgetData(endpoint, widget, payload) {
    return async (dispatch) => {
        let actionResult;
        try {
            await dispatch({
                type: WIDGET_DATA_REQUEST
            });
            actionResult = await dispatch(
                webuiState.getActionByName("request.request")(
                    {
                        method: "POST",
                        endpoint: endpoint,
                        headers: {
                            "Content-Type": "multipart/form-data"
                        },
                        payload: payload
                    },
                    {
                        widgetId: widget
                    }
                )
            );
            dispatch({
                type: WIDGET_DATA_SUCCESS,
                payload: Object.assign({}, actionResult, {
                    widget: widget
                })
            });
        } catch (error) {
            WEBUILogs.error(error);
            actionResult = Promise.reject(error);
            dispatch({
                type: WIDGET_DATA_FAILURE
            });
        }
        return actionResult;
    };
}

async function applyDataParser(dispatch, getState, actionResult, widget) {
    let dashboardId = getState().getIn(["routes", "location", "state", "dashboard", "id"]);
    let dashboardWidgets = getState().getIn(["dashboards", dashboardId, "data", "widgets"]);
    let currentWidget =
        dashboardWidgets && dashboardWidgets.filter((wid) => wid.get("id") === widget).get(0);

    if (currentWidget) {
        let inputParser = currentWidget.get("inputParser");
        let outputParser = currentWidget.get("outputParser");

        if (inputParser) {
            let language = webuiState.getGlobalProperties("locale");
            let dictionary = webuiState.getStaticTranslation(language) || {};
            let translate = (quote) => dictionary[quote] || quote;

            let parserResult = await dispatch(
                webuiState.getActionByName("request.request")({
                    method: "GET",
                    endpoint: inputParser
                })
            );
            await parserResult.text().then((res) => {
                // eslint-disable-next-line
                let resultFunction = Function("return " + res)();
                actionResult = resultFunction(actionResult, translate);
            });
        }

        if (outputParser) {
            let parserResult = await dispatch(
                webuiState.getActionByName("request.request")({
                    method: "GET",
                    endpoint: outputParser
                })
            );
            await parserResult.text().then((res) => {
                // eslint-disable-next-line
                let resultFunction = Function("return " + res)();
                webuiState.setOutputParser(dashboardId, widget, resultFunction);
            });
        }
    }
    return actionResult;
}

function fetchWidgetData(
    actionProperties = {},
    widget,
    parentWidget,
    waitInnerWidgetsLoading = false
) {
    return async (dispatch, getState) => {
        //TODO manage POST request
        let { endpoint, parameters, method = "GET" } = actionProperties;
        let actionResult;
        let dataEndpoint = endpoint;
        if (webuiState.getGlobalProperties("screenSizeQueryParameter")) {
            let size = getState().getIn(["windowSize", "size"]);
            if (size) {
                let concatSymbol = endpoint.indexOf("?") !== -1 ? "&" : "?";
                dataEndpoint = `${endpoint}${concatSymbol}screenSize=${size}`;
            }
        }
        let requestPayload = {};
        if (method === "POST") {
            let sources = [parentWidget];
            if (actionProperties.sources) {
                sources = actionProperties.sources.length ? actionProperties.sources : [];
            }
            requestPayload = constructRequestEntity(
                sources,
                getState(),
                widget,
                {
                    actionType: "loadWidgetData",
                    id: "loadWidgetData",
                    parameters: parameters
                },
                parentWidget
            );
        }
        try {
            //====== START: usage of preMadeRequests
            let preMadeRequests = webuiState.getGlobalProperties("preMadeRequests");
            if (preMadeRequests && preMadeRequests.widgets.hasOwnProperty(widget)) {
                let widgets = preMadeRequests.widgets;
                let widgetData = await widgets?.[widget];
                if(widgetData.actions){
                    dispatch(webuiState.getActionByName("siren.dispatchSirenActions")(widgetData.actions, widget));
                }
                actionResult = widgetData.content || widgetData;
                //====== END: usage of preMadeRequests
            } else {
                actionResult = await dispatch(
                    webuiState.getActionByName("request.request")(
                        {
                            method: method,
                            endpoint: dataEndpoint,
                            payload: requestPayload,
                            headers: {
                                "Content-Type": "application/json"
                            }
                        },
                        {
                            widgetId: widget
                        }
                    )
                );
            }
            actionResult = await applyDataParser(dispatch, getState, actionResult, widget);
            //to dispatch
            if (waitInnerWidgetsLoading) {
                await loadInnerWidgets(dispatch, widget, actionResult, { waitInnerWidgetsLoading });
            } else {
                loadInnerWidgets(dispatch, widget, actionResult);
            }
            dispatch({
                type: WIDGET_DATA_SUCCESS,
                payload: Object.assign({}, actionResult, {
                    widget: widget,
                    parentWidget: parentWidget
                })
            });
        } catch (error) {
            WEBUILogs.error(error);
            setErrorState(error, widget, dispatch);
            actionResult = Promise.reject(error);
        }
        return actionResult;
    };
}

export function loadWidgetData(
    actionProperties = {},
    widget,
    parentWidget,
    waitInnerWidgetsLoading
) {
    return (dispatch) => {
        if (widget) {
            return dispatch(
                fetchWidgetData(actionProperties, widget, parentWidget, waitInnerWidgetsLoading)
            );
        } else {
            return Promise.reject("Promise: ProcessStep action failed.");
        }
    };
}

function fetchWidgetConfig(endpoint, widget, dataUrl, contextId) {
    let { WIDGETS_ROOT } = webuiState.getWebConfig();
    let widgetId = widget;
    let configEndpoint = endpoint ? endpoint : WIDGETS_ROOT + `/${widget}/configuration`;
    return async (dispatch, getState) => {
        if (webuiState.getGlobalProperties("screenSizeQueryParameter")) {
            let size = getState().getIn(["windowSize", "size"]);
            if (size) {
                let concatSymbol = configEndpoint.indexOf("?") !== -1 ? "&" : "?";
                configEndpoint += `${concatSymbol}screenSize=${size}`;
            }
        }
        let actionResult;
        try {
            await dispatch({
                type: WIDGET_REQUEST
            });
            let options = {
                method: "GET",
                endpoint: configEndpoint
            };
            const { STATIC_CONFIGURATIONS_ROOT } = webuiState.getWebConfig();
            if (STATIC_CONFIGURATIONS_ROOT) {
                options.endpoint =
                    STATIC_CONFIGURATIONS_ROOT + configEndpoint.split("?")[0] + ".json";
                options.rawEndpointUrl = true;
            }
            const urlParser = webuiState.getStaticConfigUrlParser({ contextId, widgetId });
            if (urlParser) {
                options.endpoint = await urlParser({
                    context: "widget",
                    endpoint: configEndpoint,
                    id: widgetId
                });
                options.rawEndpointUrl = true;
            }
            //application is responsible for loading static configuration
            const staticConfigLoader = webuiState.getStaticConfigLoader({ contextId, widgetId });
            const lazyModuleLoader = webuiState.getLazyModuleLoader({ contextId, widgetId });
            if (staticConfigLoader) {
                actionResult = await staticConfigLoader.load({
                    id: widgetId,
                    type: "widget",
                    defaultRequestOptions: options
                });
            } else if (lazyModuleLoader) {
                let module = await lazyModuleLoader.load({
                    id: widgetId,
                    type: "widget"
                });
                actionResult = module.config;
                //widget module can set widget context
                if (module.context) {
                    setWidgetContext(widgetId, module.contest);
                }
            } else {
                //default behavior is to make a request for UI configuration
                actionResult = await dispatch(
                    webuiState.getActionByName("request.request")(options, {
                        widgetId: widgetId
                    })
                );
            }
            actionResult = await loadMissingComponents({ config: actionResult, widgetId });
            dispatch({
                type: WIDGET_SUCCESS,
                payload: Object.assign({}, actionResult, {
                    widget: widgetId,
                    endpoint: dataUrl
                })
            });
        } catch (error) {
            WEBUILogs.error(error);
            setErrorState(error, widget, dispatch);
            actionResult = Promise.reject(error);
        }
        return actionResult;
    };
}

export function loadWidgetConfig(configEndpoint, widget, dataUrl, context) {
    return (dispatch) => {
        if (widget) {
            return dispatch(fetchWidgetConfig(configEndpoint, widget, dataUrl, context));
        } else {
            return Promise.reject("Promise: LoadWidgetConfig action failed.");
        }
    };
}

export function reloadWidget(sirenAction) {
    WEBUILogs.log("reloadWidget");
    return async (dispatch) => {
        if (sirenAction.widgetLoading) {
            dispatch(
                webuiState.getActionByName("loading.triggerWidgetLoading")(sirenAction.id, true)
            );
        }

        let result = await dispatch(
            refetchWidget(sirenAction.config, sirenAction.id, sirenAction.data)
        );

        if (sirenAction.widgetLoading) {
            dispatch(
                webuiState.getActionByName("loading.triggerWidgetLoading")(sirenAction.id, false)
            );
        }
        return result;
    };
}

function refetchWidget(endpoint, widget, dataEndpoint) {
    let { WIDGETS_ROOT } = webuiState.getWebConfig();
    let widgetId = widget;
    let configEndpoint = endpoint ? endpoint : WIDGETS_ROOT + `/${widget}/configuration`;
    return async (dispatch) => {
        let actionResult;
        try {
            await dispatch({
                type: RELOAD_WIDGET_REQUEST
            });
            actionResult = await dispatch(
                webuiState.getActionByName("request.request")(
                    {
                        method: "GET",
                        endpoint: configEndpoint
                    },
                    {
                        widgetId: widgetId
                    }
                )
            );
            dispatch({
                type: RELOAD_WIDGET_SUCCESS,
                payload: Object.assign({}, actionResult, {
                    widget: widgetId,
                    endpoint: dataEndpoint
                })
            });
            dispatch(fetchWidgetData({ endpoint: dataEndpoint }, widgetId));
        } catch (error) {
            WEBUILogs.error(error);
            actionResult = Promise.reject(error);
            dispatch({
                type: RELOAD_WIDGET_FAILURE
            });
        }
        return actionResult;
    };
}

export function sendWidget(sirenAction, widgetId) {
    return (dispatch, getState) => {
        let endpoint = getWidgetUrl(widgetId, getState());
        let widgetData = getState().getIn(["data", widgetId]);
        let widgetConfig = getState().getIn(["config", widgetId]);
        let jsonData = widgetData.toJS ? widgetData.toJS() : null;
        let jsonConfig = widgetConfig.toJS ? widgetConfig.toJS() : null;

        let widgetDataFormat = formatData(jsonData);
        let widgetConfigFormat = formatConfig(jsonConfig);

        let formData = new FormData();

        formData.append(
            "json",
            JSON.stringify({ widgetData: widgetDataFormat, widgetConfig: widgetConfigFormat })
        );

        return dispatch(sendWidgetDataConfig(endpoint, widgetId, formData));
    };
}

function sendWidgetDataConfig(endpoint, widget, payload) {
    return async (dispatch) => {
        let actionResult;
        try {
            await dispatch({
                type: SEND_WIDGET_DATA_CONFIG_REQUEST
            });
            actionResult = await dispatch(
                webuiState.getActionByName("request.request")(
                    {
                        method: "POST",
                        endpoint: endpoint,
                        headers: {
                            "Content-Type": "multipart/form-data"
                        },
                        payload: payload
                    },
                    {
                        widgetId: widget
                    }
                )
            );
            dispatch({
                type: SEND_WIDGET_DATA_CONFIG_SUCCESS,
                payload: Object.assign({}, payload, actionResult, {
                    widget: widget
                })
            });
        } catch (error) {
            WEBUILogs.error(error);
            actionResult = Promise.reject(error);
            dispatch({
                type: SEND_WIDGET_DATA_CONFIG_FAILURE
            });
        }
        return actionResult;
    };
}

export function reloadWidgetConfigData(widgetConfig = {}) {
    return async (dispatch) => {
        let id = widgetConfig.id;
        let dataUrl = widgetConfig.href;
        let configUrl = `${dataUrl}/configuration`;
        if (dataUrl.includes("?")) {
            let widgetResourceSplit = dataUrl.split("?");
            let urlParams = widgetResourceSplit[1];
            configUrl = `${widgetResourceSplit[0]}/configuration?${urlParams}`;
        }

        let parentWidget = widgetConfig.parentWidget;
        let result = await Promise.all([
            dispatch(loadWidgetConfig(configUrl, id, dataUrl)),
            dispatch(loadWidgetData({ endpoint: dataUrl }, id, parentWidget))
        ]);

        await dispatch(triggerActionsOnLoadData(id));

        return result;
    };
}
export function loadWidget(
    widgetConfig = {},
    skipLoadingAnimation = false,
    queryParameters = {},
    waitInnerWidgetsLoading = false
) {
    return async (dispatch, getState) => {
        let {
            id,
            parentWidget,
            cached,
            href,
            //POST/GET default: GET
            method,
            sources,
            context
            //name
        } = widgetConfig;
        let staticWidgetConfig = getState().getIn(["config", widgetConfig.id, "static"]);
        let widgetDataLoaded = getState().getIn(["data", widgetConfig.id]);
        //cached possible values:
        //undefined = false = "none", "config", "data", "all" = true
        //"config" and "data" to be developed (no use case available)
        if ((cached === "all" || cached === true) && widgetDataLoaded) {
            return;
        }
        //questionable logic, perhaps issue is with unique widget names in the current version
        if (staticWidgetConfig && widgetDataLoaded) {
            let parentWidget = widgetDataLoaded.get("parentWidget");
            if (parentWidget && widgetConfig.parentWidget === parentWidget) {
                return;
            }
        }
        await dispatch(createWidget({ widget: widgetConfig.id, context, parentWidget }));
        //let id = widgetConfig.id;
        //let configUrl = widgetConfig.config;
        //let dataUrl = widgetConfig.data;
        //if (widgetConfig.hasOwnProperty("href")) {
        //let widgetResource = widgetConfig.href;
        let dataUrl = href;
        if (method !== "POST") {
            dataUrl = addQueryParams(href, queryParameters);
        }
        let urlParams = "";
        let configResource = `${href}/configuration`;
        if (href.includes("?")) {
            let widgetResourceSplit = href.split("?");
            urlParams = widgetResourceSplit[1];
            configResource = `${widgetResourceSplit[0]}/configuration?${urlParams}`;
        }
        let configUrl = configResource;
        if (method !== "POST") {
            configUrl = addQueryParams(configResource, queryParameters);
        }

        let widgetType = widgetConfig.type || "widget";
        //let parentWidget = widgetConfig.parentWidget;

        let result;
        //to remove the logic for load of widget container
        //pass it to the places where the loading happens
        if (widgetType === "widgetContainer") {
            await dispatch(
                webuiState.getActionByName("widgetContainer.loadWidgetContainer")(
                    widgetConfig,
                    (skipLoadingAnimation = false),
                    queryParameters,
                    waitInnerWidgetsLoading
                )
            );
            return dispatch(triggerActionsOnLoadData(id));
        } else {
            if (!skipLoadingAnimation) {
                await dispatch(
                    webuiState.getActionByName("loading.triggerWidgetLoading")(id, true)
                );
            }
            //pass parameters for POST data request - method, sources, href
            result = await Promise.all([
                dispatch(loadWidgetConfig(configUrl, id, dataUrl, context)),
                dispatch(
                    loadWidgetData(
                        {
                            endpoint: dataUrl,
                            parameters: queryParameters,
                            method,
                            sources
                        },
                        id,
                        parentWidget,
                        waitInnerWidgetsLoading
                    )
                )
            ]);
        }

        await dispatch(triggerActionsOnLoadData(id));

        if (!skipLoadingAnimation) {
            dispatch(webuiState.getActionByName("loading.triggerWidgetLoading")(id, false));
        }
        return result;
    };
}

//update widget entities
//entityPaths = [[truePath1], [truePath2],..]
export function updateWidgetEntity(sirenAction, widgetId) {
    let dependencies = sirenAction.dependencies || [];
    let dependencyPaths = [];

    if (!dependencies.length) {
        return Promise.reject("updateEntity action failed: missing dependencies.");
    }
    return (dispatch, getState) => {
        dependencyPaths = getDependentPaths(dependencies, getState());

        if (!dependencyPaths.length) {
            return Promise.reject("updateEntity action failed: no correct dependencies found");
        }

        let widgetData = getState().getIn(["data", widgetId]);
        let payload;

        let endpoint = sirenAction.href;

        if (widgetData && widgetData.toJS()) {
            let outputParser = getOutputParser(widgetId, getState());
            payload = createFormData(widgetData.toJS(), sirenAction, outputParser, widgetId);
            return dispatch(updateEntity(widgetId, dependencyPaths, endpoint, payload));
        }
        return Promise.reject();
    };
}

function updateEntity(widgetId, entityPaths, endpoint, payload) {
    return async (dispatch) => {
        let actionResult;
        try {
            await dispatch({
                type: WIDGET_UPDATE_ENTITY_REQUEST
            });
            actionResult = await dispatch(
                webuiState.getActionByName("request.request")(
                    {
                        method: "POST",
                        endpoint: endpoint,
                        headers: {
                            "Content-Type": "multipart/form-data"
                        },
                        payload: payload
                    },
                    {
                        widgetId: widgetId
                    }
                )
            );
            dispatch({
                type: WIDGET_UPDATE_ENTITY_SUCCESS,
                payload: Object.assign({}, payload, actionResult, {
                    widget: widgetId,
                    destinationPaths: entityPaths
                })
            });
        } catch (error) {
            WEBUILogs.error(error);
            actionResult = Promise.reject(error);
            dispatch({
                type: WIDGET_UPDATE_ENTITY_FAILURE
            });
        }
        return actionResult;
    };
}

export function getWidgetUrl(widgetId, state) {
    return state.getIn(["config", widgetId, "endpoint"]);
}

export function getOutputParser(widgetId, state) {
    let dashboardId = state.getIn(["routes", "location", "state", "dashboard", "id"]);
    return webuiState.getOutputParser(dashboardId, widgetId);
}

export function setWidgetErrorState(widgetId, widgetState) {
    return {
        type: SET_WIDGET_STATE,
        payload: {
            widget: widgetId,
            state: widgetState
        }
    };
}

//this function is triggered when widget/step loadData are completed
export function triggerActionsOnLoadData(widgetId) {
    const dispatchSirenActions = webuiState.getActionByName("siren.dispatchSirenActions");
    //const getStepData = webuiState.getActionByName("flow.getStepData");
    return (dispatch, getState) => {
        let state = getState();
        let currentPath = state.getIn(["data", widgetId, "class", 0]);
        let widgetActions = state.getIn(["data", widgetId, "actions"]);
        //in flow context the id is different than the flow class
        // let stepData;
        // if (stepId) {
        //     stepData = getStepData(state, widgetId, stepId);
        //     if (stepData) {
        //         widgetActions = stepData.getIn(["actions"]);
        //     }
        //     currentPath = widgetClass + "." + stepId;
        // }

        if (widgetActions && widgetActions.toJS) {
            return dispatch(
                dispatchSirenActions(widgetActions.toJS(), widgetId, currentPath, "load")
            );
        }
        return Promise.resolve();
    };
}

export function createWidget({ widget, parentWidget, context } = {}) {
    const payload = { widget };
    if (parentWidget) {
        payload.parentWidget = parentWidget;
    }
    if (context) {
        payload.context = context;
    }
    return {
        type: WIDGET_DATA_UPDATE,
        payload
    };
}

export function setWidgetContext(widgetId, context) {
    return {
        type: WIDGET_DATA_UPDATE,
        payload: {
            widget: widgetId,
            context: context
        }
    };
}

export function setErrorState(error, widget, dispatch) {
    if (error.name === "ApiError") {
        const setWidgetErrorState = webuiState.getActionByName("widget.setWidgetErrorState");
        let errorMessage = error.message || translationService.translate("renderErrorMessage");
        let widgetState = {
            state: "error",
            message: errorMessage
        };
        dispatch(setWidgetErrorState(widget, widgetState));
    }
}
